import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import filteredObjectsSelector from 'functions/filteredObjectsSelector'
import { objectsToArray, sortArrayBy } from 'functions/utilities'
import currencyFormat from 'functions/currencyFormat'

const sortItems = (campaignQuoteItems) => {
  const array = objectsToArray(campaignQuoteItems).filter(item => item.selected)
  return sortArrayBy(array, 'asc', 'sort')
}

const calculateTotal = itemArray => itemArray.reduce((acc, item) => acc + item.price_override, 0)

class QuoteSectionWrapper extends React.Component {
  render(){
    const { campaignQuoteItems, campaignQuoteSection, render } = this.props

    const hidePrices = campaignQuoteSection.options && campaignQuoteSection.options.hide_prices
    const showSubtotal = campaignQuoteSection.options && campaignQuoteSection.options.show_subtotal

    const sortedItems = sortItems(campaignQuoteItems)
    const subtotal = calculateTotal(sortedItems)

    return render({
      hidePrices,
      showSubtotal,
      formattedSubtotal: showSubtotal ? currencyFormat(subtotal) : null,
      subtotal: showSubtotal ? subtotal : null,
      quoteItems: sortedItems,
    })
  }
}

QuoteSectionWrapper.propTypes = {
  campaignQuoteSection: PropTypes.object.isRequired,
  campaignQuoteItems: PropTypes.object.isRequired,
  render: PropTypes.func.isRequired,
}

function mapStateToProps(state, props){
  const { campaignQuoteSection } = props

  return {
    campaignQuoteItems: filteredObjectsSelector(
      state,
      'campaignQuoteItems',
      'campaign_quote_section_id',
      campaignQuoteSection.id,
    ),
  }
}

export default connect(mapStateToProps)(QuoteSectionWrapper)
